

























import { Component, Prop, Vue, Watch, Emit } from 'vue-property-decorator';
import Option from '@/models/Option';
@Component({})
export default class FilterMultiSelect extends Vue {
  @Prop({ required: true })
  public items!: Array<Option>;

  @Prop({ required: true })
  public value!: Array<string | number | boolean>;

  @Watch('value', { deep: true })
  protected onValueChanged() {
    this.valueInternal = [...this.value];
  }

  protected valueInternal: Array<string | number | boolean> = [];

  public removeItem(value: string | number | boolean) {
    this.valueInternal = [...this.valueInternal.filter(x => x !== value)];
    this.input(this.valueInternal);
    this.change(this.valueInternal);
  }

  @Emit()
  public input(value: Array<string | number | boolean>) {
    return value;
  }

  @Emit()
  public change(value: Array<string | number | boolean>) {
    return value;
  }
}
